// extracted by mini-css-extract-plugin
export var askAiIcon = "_ow-9";
export var container = "_ow-0";
export var groupSeparator = "_ow-a";
export var highlight = "_ow-4";
export var resultIcon = "_ow-5";
export var resultItem = "_ow-7";
export var resultSubtitle = "_ow-3";
export var resultTitle = "_ow-2";
export var resultsList = "_ow-1";
export var searchGroup = "_ow-6";
export var selected = "_ow-8";